import { render, staticRenderFns } from "./TeamFormationSelector.vue?vue&type=template&id=83d72f20&"
import script from "./TeamFormationSelector.vue?vue&type=script&lang=js&"
export * from "./TeamFormationSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports